module.exports = function() {
  return new Worker(__webpack_public_path__ + "08f676f6bc859c51c26a.worker.js");
};